import { Route } from '@angular/router';

import { CompanyCooperationsViewComponent } from './company-cooperations/company-cooperations-view.component';
import { CooperationsComponent } from './cooperations.component';
import { IncomingCooperationViewComponent } from './incoming-cooperation-view/incoming-cooperation-view.component';
import { OutgoingCooperationViewComponent } from './outgoing-cooperation-view/outgoing-cooperation-view.component';

export const cooperationsRoutes: Route[] = [
  {
    path: '',
    component: CooperationsComponent,
    children: [
      {
        path: '',
        component: CompanyCooperationsViewComponent
      },
      {
        path: 'incoming/:cooperation-id',
        component: IncomingCooperationViewComponent
      },
      {
        path: 'outgoing/:cooperation-id',
        component: OutgoingCooperationViewComponent
      }
    ]
  }
];
